import "./partnership.css";
import articleImg from "../../assets/images/partnership.webp";
import { useTranslation } from "../../shared/LanguageContext";

const ARTICLE_URL = "https://www.gazeta.uz/ru/2025/06/19/oq-saroy/";

const NewsFeature = () => {
    const { t } = useTranslation();
    return (
    <section className="news-feature-section">
        <div className="news-feature-card">
            <div className="news-feature-image">
                <img src={articleImg} alt="Oqsaroy Hospital в Gazeta.uz" />
            </div>
            <div className="news-feature-content">
                <span className="news-feature-label">{t("partner_label")}</span>
                <h3>
                    {t("partner_title")}
                </h3>
                <p>
                    {t("partner_desc")}
                </p>
                <div className="news-feature-actions">
                    <a
                        href={ARTICLE_URL}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="news-feature-btn"
                    >
                        {t("partner_btn")}
                    </a>
                </div>
            </div>
        </div>
    </section>
    );
};

export default NewsFeature;
